export const payoutStatus = {
  success: 1,
  fail: 2,
  penalty: 3,
  edit: 4,
  wait: 5
};

export const payoutOptions = [
  { label: "Оплачен", value: payoutStatus.success },
  { label: "Не оплачен", value: payoutStatus.fail },
  { label: "Штраф", value: payoutStatus.penalty },
  { label: "Ошибка", value: payoutStatus.edit },
  { label: "В процессе", value: payoutStatus.wait }
];

export const payoutName = payoutOptions.reduce((result, current) => {
  result[current.value] = current.label;
  return result;
}, {});

export const gradeStatus = {
  wait: 1,
  payed: 2,
  notPayed: 3
};

export const gradeStatusOptions = [
  { label: "Оценка", value: gradeStatus.wait },
  { label: "Оплачен", value: gradeStatus.payed },
  { label: "Не оплачен", value: gradeStatus.notPayed }
];

export const gradeStatusName = {
  [gradeStatus.wait]: "Оценка",
  [gradeStatus.payed]: "Оплачен",
  [gradeStatus.notPayed]: "Не оплачен"
};

export const teaserStatus = {
  active: 1,
  inactive: 0,
  moderate: 2,
  reject: 3,
  delete: 4,

  canShow: -1,
  activeNow: -2
};

export const teaserStatusName = {
  [teaserStatus.active]: "Активный",
  [teaserStatus.inactive]: "Неактивный",
  [teaserStatus.moderate]: "На модерации",
  [teaserStatus.reject]: "Отклонен",
  [teaserStatus.delete]: "Удален"
};

export const teaserStatusOptions = [
  { label: "Активные", value: teaserStatus.active },
  { label: "Неактивные", value: teaserStatus.inactive },
  { label: "Отклонен", value: teaserStatus.reject },
  { label: "На модерации", value: teaserStatus.moderate }
];

export const showStatus = {
  all: 0,
  top: 1,
  inf: 2
};

export const showTypeOptions = [
  {
    label: "Везде",
    value: showStatus.all
  },
  {
    label: "Топ",
    value: showStatus.top
  },
  {
    label: "Инф",
    value: showStatus.inf
  }
];

export const showTypeName = showTypeOptions.reduce((result, current) => {
  result[current.value] = current.label;
  return result;
}, {});

export const notificationType = {
  cardDone: "CARD_DONE",
  cardFail: "CARD_FAIL",
  cardTakeOff: "CARD_TAKE_OFF",
  teaserError: "TEASER_ERROR",
  teaserPenalty: "TEASER_PENALTY",
  simple: "simple"
};

export const campaignTypes = {
  ad: 2,
  ex: 1,
  wm: 3,
  sys: 4
};

export const campaignTypeName = {
  2: "Реклама",
  1: "Обмен",
  3: "Вебмастер",
  4: "Системная"
};

export const detalization = {
  day: "day",
  week: "week",
  month: "month",
  quarter: "quarter",
  year: "year"
};

export const categoryGroups = {
  exchange: 1,
  media: 2,
  partner: 3,
  goods: 4,
  aggregator: 5,
  system: 6
};

export const categoryGroupItems = [
  { title: "Обмен", code: categoryGroups.exchange },
  { title: "Медиа", code: categoryGroups.media },
  { title: "Партнерские материалы", code: categoryGroups.partner },
  { title: "Товары", code: categoryGroups.goods },
  { title: "Аггрегатор", code: categoryGroups.aggregator },
  { title: "Системные", code: categoryGroups.system }
];

export const categoryGroupNames = {
  [categoryGroups.exchange]: "Обмен",
  [categoryGroups.media]: "Медиа",
  [categoryGroups.partner]: "Партнерские материалы",
  [categoryGroups.goods]: "Товары",
  [categoryGroups.aggregator]: "Аггрегатор",
  [categoryGroups.system]: "Системные"
};

export const authorGroups = {
  editors: -1,
  owners: -2
};

export const geoShort = {
  88: "Бря.нобл",
  55: "Вла-ок",
  89: "Влад.об",
  78: "Вол-рад",
  54: "Воронеж",
  56: "Екб",
  63: "Казань",
  76: "Калуга",
  92: "Кем-об",
  83: "Кир-обл",
  82: "Крд-край",
  65: "Красноярск ",
  62: "Москва",
  84: "Нижег-обл",
  58: "Новосиб",
  68: "Омск",
  72: "Оренбург",
  90: "Орл-обл",
  75: "Пенза",
  71: "РнД",
  64: "Рязань",
  52: "Саратов",
  94: "Сев-Зап",
  69: "Арх-обл",
  79: "Волог-обл",
  57: "Кал-гра-обл",
  87: "Карелия",
  97: "Лен-обл",
  81: "Мурм-обл",
  95: "Ненец-ао",
  98: "Новг-обл",
  99: "Псков-область",
  96: "Коми",
  10: "СПБ",
  67: "Смоленск",
  80: "Татарстан",
  70: "Тверь",
  59: "Тольяти",
  77: "Томск",
  73: "Тула",
  86: "Тюмен-обл",
  74: "Удмуртия",
  53: "Уфа",
  91: "ХМАО",
  60: "Чебоксары",
  66: "Челяб",
  61: "Ярославль",
  85: "Севастополь"
};

export const buyoutStatus = [
  { value: "active", label: "Активные" },
  { value: "all", label: "Все" },
  { value: "archived", label: "В архиве" }
];

export const changeLogAction = {
  create: 1,
  editContent: 2,
  editCpc: 3,
  editPublished: 4,
  copy: 5,
  restart: 6,
  moderate: 7,
  editType: 8,
  editTTL: 9,
  editPayoutStatus: 10,
  editGradeStatus: 11,
  mpaa: 12
};

export const changeLogActionNames = {
  [changeLogAction.create]: "Создание",
  [changeLogAction.editContent]: "Содержание",
  [changeLogAction.editCpc]: "CPC",
  [changeLogAction.editPublished]: "Статус",
  [changeLogAction.copy]: "Копирование",
  [changeLogAction.restart]: "Перезакидывание",
  [changeLogAction.moderate]: "Модерация",
  [changeLogAction.editType]: "Область показов",
  [changeLogAction.editTTL]: "Время жизни",
  [changeLogAction.editPayoutStatus]: "Оплата",
  [changeLogAction.editGradeStatus]: "Оценка",
  [changeLogAction.mpaa]: "Рейтинг MPA"
};

export const changeLogActionOptions = Object.keys(changeLogActionNames).map(
  key => {
    return { value: key, label: changeLogActionNames[key] || key };
  }
);

export const changeLogActionType = {
  single: 1,
  batch: 2
};

export const changeLogActionTypeName = {
  1: "Одиночное",
  2: "Групповое"
};

export const changeLogActionTypeOptions = [
  { value: 1, label: "Одиночное" },
  { value: 2, label: "Групповое" }
];

export const categoryGroup = {
  exchange: 1,
  media: 2,
  partner: 3,
  goods: 4,
  aggregator: 5,
  system: 6
};

export const categoryGroupOptions = [
  { value: categoryGroup.exchange, label: "Обмен" },
  { value: categoryGroup.media, label: "Медиа" },
  { value: categoryGroup.partner, label: "Парнер" },
  { value: categoryGroup.goods, label: "Товары" },
  { value: categoryGroup.aggregator, label: "Аггрегатор" },
  { value: categoryGroup.system, label: "Системные" }
];

export const userTypeOptions = [
  { value: "content", label: "Редакторы" },
  { value: "partner", label: "Партнеры" },
  { value: "dash", label: "Администрация" },
  { value: "moderator", label: "Модераторы" }
];
